import { useState } from "react"

export const Payment = () => {
    const [parameter, setParameter] = useState({from: '', to: ''})
    const [openView, setOpenView] = useState(false)
    const [record, setRecord] = useState({list: [], loader: false, total_sales: 0, total_fees: 0, total_net_amount: 0})
    const [paidView, setPaidView] = useState({loader: false, list: [], total_sales: 0, total_fees: 0, total_net_amount: 0, transfer_charges: 0, payment_reference_number: '', name: '', link:'', account_number: '', bank_name: ''})
    
    return {
        parameter: {data: parameter, set: setParameter},
        openView: {data: openView, set: setOpenView},
        record: {data: record, set: setRecord},
        paidView: {data: paidView, set: setPaidView},
    } 
}
